import { Entity } from '../../Model/Implementation/Entity';

export default function equalsEntity(entityA: Entity | undefined,
                                     entityB: Entity | undefined)
{
    return entityA !== undefined
        && entityB !== undefined
        && entityA.uuid === entityB.uuid;
}
